import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mainDrawer" }

import { inject } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationDrawer',
  emits: [`sendToEmit`],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const store: any = inject(`store`);
const anchorList = store.getters.getNavAnchorList;

function sendTo(to: string | null) {
  emit(`sendToEmit`, to);
}

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseAnchor = _resolveComponent("BaseAnchor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseButton, {
      class: "element",
      color: "white",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (sendTo(`contact`))),
      text: "Request a quote"
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(anchorList), (anchor) => {
      return (_openBlock(), _createBlock(_component_BaseAnchor, {
        class: "element",
        key: anchor.text,
        theme: "black",
        text: anchor.text,
        onClick: ($event: any) => (sendTo(anchor.to))
      }, null, 8, ["text", "onClick"]))
    }), 128))
  ]))
}
}

})